/**
 * UserCompanyAccessViewElement — blok „Dostęp do firm" jako przenośny klocek
 * kreatora layoutu (konfigurowalne zakładki, kartoteka Użytkownicy).
 *
 * Mirror `EmployeeAccountViewElement` / `ContractorCompanyAccessViewElement` —
 * element „widokowy" (panel: macierz dostępu user↔firmy + role, nie tabela kolumn →
 * brak formatki). Na realnej stronie dispatchowany przez
 * `UserDetail` contextRenderers['user_company_access_view'] (→ UserCompanyAccessTab
 * w trybie edit, UserCreateAccessFields w trybie create); w builderze stub z rejestru.
 * `allowedModules: ['users']` — widoczny w palecie tylko dla Użytkowników.
 *
 * `render` wołany jak funkcja — bez hooków w ciele (i18n.t standalone).
 */

import { Building2 } from 'lucide-react';

import type { LayoutElementDefinition } from '@/components/fields/LayoutElementRegistry';
import i18n from '@/i18n';

export const UserCompanyAccessViewElement: LayoutElementDefinition = {
  type: 'user_company_access_view',
  category: 'tresc',
  isContainer: false,
  label: 'Dostęp do firm',
  icon: 'building',
  allowedModules: ['users'],
  defaultSettings: () => ({}),
  render: ({ element }) => (
    <div
      className="rounded-lg border border-dashed border-border-secondary bg-bg-secondary p-4 text-center"
      data-testid={`user-company-access-view-element-${element.id}`}
      data-element-type="user_company_access_view"
    >
      <Building2 className="mx-auto h-5 w-5 text-text-muted" aria-hidden="true" />
      <p className="mt-1 text-xs font-medium text-text-secondary">
        {i18n.t('tenant.users.companyAccessBlock.paletteLabel', {
          defaultValue: 'Dostęp do firm',
        })}
      </p>
    </div>
  ),
};
